import { gql } from '@/__generated__';

export const GET_GATE_LIMITS_DATA = gql(`#graphql
  query GetGateLimitsData($gateId: ID!) {
    gate(input: { id: $gateId }) {
      id
      dataConfiguration {
        minPosition
        maxPosition
      }
      movements2 {
        id
        lastPosition
        unit
        precision
      }
    }
  }
`);
